"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_brand_1 = require("@giphy/js-brand");
var js_util_1 = require("@giphy/js-util");
var moat_loader_1 = __importDefault(require("@giphy/moat-loader"));
var emotion_1 = require("emotion");
var react_1 = __importStar(require("react"));
var pingback = __importStar(require("../util/pingback"));
var ad_pill_1 = __importDefault(require("./ad-pill"));
var overlay_1 = __importDefault(require("./attribution/overlay"));
exports.PingbackContext = react_1.createContext({});
var moatLoader = moat_loader_1.default.loadMoatTag('giphydisplay879451385633');
var gifCss = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n"], ["\n    display: block;\n"])));
exports.GRID_COLORS = [js_brand_1.giphyBlue, js_brand_1.giphyGreen, js_brand_1.giphyPurple, js_brand_1.giphyRed, js_brand_1.giphyYellow];
exports.getColor = function () { return exports.GRID_COLORS[Math.round(Math.random() * (exports.GRID_COLORS.length - 1))]; };
var hoverTimeoutDelay = 200;
var Container = function (props) {
    return props.href ? react_1.default.createElement("a", __assign({}, props)) : react_1.default.createElement("div", __assign({}, props));
};
var placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var noop = function () { };
var Gif = function (_a) {
    var gif = _a.gif, _b = _a.gif.bottle_data, bottleData = _b === void 0 ? {} : _b, width = _a.width, forcedHeight = _a.height, _c = _a.onGifRightClick, onGifRightClick = _c === void 0 ? noop : _c, className = _a.className, _d = _a.onGifClick, onGifClick = _d === void 0 ? noop : _d, _e = _a.onGifSeen, onGifSeen = _e === void 0 ? noop : _e, _f = _a.onGifVisible, onGifVisible = _f === void 0 ? noop : _f, _g = _a.user, user = _g === void 0 ? {} : _g, backgroundColor = _a.backgroundColor, overlay = _a.overlay, _h = _a.hideAttribution, hideAttribution = _h === void 0 ? false : _h, _j = _a.noLink, noLink = _j === void 0 ? false : _j;
    // only fire seen once per gif id
    var _k = react_1.useState(false), hasFiredSeen = _k[0], setHasFiredSeen = _k[1];
    // hovered is for the gif overlay
    var _l = react_1.useState(false), isHovered = _l[0], setHovered = _l[1];
    // only show the gif if it's on the screen
    var _m = react_1.useState(false), showGif = _m[0], setShowGif = _m[1];
    // only render the img after we check for webp
    var _o = react_1.useState(false), ready = _o[0], setReady = _o[1];
    // the background color shouldn't change unless it comes from a prop or we have a sticker
    var defaultBgColor = react_1.useRef(exports.getColor());
    // the a tag the media is rendered into
    var container = react_1.useRef(null);
    // intersection observer with no threshold
    var showGifObserver = react_1.useRef();
    // intersection observer with a threshold of 1 (full element is on screen)
    var fullGifObserver = react_1.useRef();
    // fire hover pingback after this timeout
    var hoverTimeout = react_1.useRef();
    // fire onseen ref (changes per gif, so need a ref)
    var sendOnSeen = react_1.useRef(noop);
    // custom pingback
    var attributes = react_1.useContext(exports.PingbackContext).attributes;
    // moat ad number
    var moatAdNumber = react_1.useRef();
    // are we displaying an ad
    var isAd = Object.keys(bottleData).length > 0;
    // user's overlay
    var Overlay = overlay;
    if (!Overlay && !hideAttribution) {
        // no user overlay, and no force hide of the attribution
        Overlay = overlay_1.default;
    }
    var onMouseOver = function (e) {
        clearTimeout(hoverTimeout.current);
        e.persist();
        setHovered(true);
        hoverTimeout.current = window.setTimeout(function () {
            pingback.onGifHover(gif, user, e.target, attributes);
        }, hoverTimeoutDelay);
    };
    var onMouseLeave = function () {
        clearTimeout(hoverTimeout.current);
        setHovered(false);
    };
    var onClick = function (e) {
        // fire pingback
        pingback.onGifClick(gif, user, e.target, attributes);
        onGifClick(gif, e);
    };
    // using a ref in case `gif` changes
    sendOnSeen.current = function (entry) {
        // flag so we don't observe any more
        setHasFiredSeen(true);
        js_util_1.Logger.debug("GIF " + gif.id + " seen. " + gif.title);
        // third party here
        if (gif.bottle_data && gif.bottle_data.tags) {
            js_util_1.injectTrackingPixel(gif.bottle_data.tags);
        }
        // fire pingback
        pingback.onGifSeen(gif, user, entry.boundingClientRect, attributes);
        // fire custom onGifSeen
        onGifSeen === null || onGifSeen === void 0 ? void 0 : onGifSeen(gif, entry.boundingClientRect);
        // disconnect
        if (fullGifObserver.current) {
            fullGifObserver.current.disconnect();
        }
    };
    var trackWithMoat = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bottleData_1, moatCompatibleData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(showGif && container.current)) return [3 /*break*/, 2];
                    bottleData_1 = gif.bottle_data;
                    moatCompatibleData = js_util_1.constructMoatData(bottleData_1);
                    if (!moatCompatibleData) return [3 /*break*/, 2];
                    return [4 /*yield*/, moatLoader];
                case 1:
                    _a.sent();
                    if (container.current) {
                        moatAdNumber.current = moat_loader_1.default.startTracking(container.current, moatCompatibleData);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var onImageLoad = function (e) {
        if (!fullGifObserver.current) {
            fullGifObserver.current = new IntersectionObserver(function (_a) {
                var entry = _a[0];
                if (entry.isIntersecting) {
                    sendOnSeen.current(entry);
                }
            }, { threshold: [1] });
        }
        if (!hasFiredSeen && container.current && fullGifObserver.current) {
            // observe img for full gif view
            fullGifObserver.current.observe(container.current);
        }
        if (isAd) {
            if (moatAdNumber.current === undefined) {
                trackWithMoat();
            }
        }
        onGifVisible(gif, e); // gif is visible, perhaps just partially
    };
    var checkForWebP = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, js_util_1.checkIfWebP];
                case 1:
                    _a.sent();
                    setReady(true);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (fullGifObserver.current) {
            fullGifObserver.current.disconnect();
        }
        setHasFiredSeen(false);
    }, [gif.id]);
    var stopTracking = function () {
        // if we have a moat ad number
        if (moatAdNumber.current !== undefined) {
            // stop tracking
            moat_loader_1.default.stopTracking(moatAdNumber.current);
            // remove the moat ad number
            moatAdNumber.current = undefined;
        }
    };
    // if this component goes from showing an ad to not an ad
    react_1.useEffect(function () {
        if (!showGif) {
            stopTracking();
        }
    }, [showGif]);
    react_1.useEffect(function () {
        checkForWebP();
        showGifObserver.current = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            var isIntersecting = entry.isIntersecting;
            // show the gif if the container is on the screen
            setShowGif(isIntersecting);
            // remove the fullGifObserver if we go off the screen
            // we may have already disconnected if the hasFiredSeen happened
            if (!isIntersecting && fullGifObserver.current) {
                fullGifObserver.current.disconnect();
            }
        });
        showGifObserver.current.observe(container.current);
        return function () {
            if (showGifObserver.current)
                showGifObserver.current.disconnect();
            if (fullGifObserver.current)
                fullGifObserver.current.disconnect();
            if (hoverTimeout.current)
                clearTimeout(hoverTimeout.current);
            stopTracking();
        };
    }, []);
    var height = forcedHeight || js_util_1.getGifHeight(gif, width);
    var fit = ready ? js_util_1.getBestRenditionUrl(gif, width, height) : placeholder;
    var background = backgroundColor || // <- specified background prop
        // sticker has black if no backgroundColor is specified
        (gif.is_sticker
            ? "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC') 0 0"
            : defaultBgColor.current);
    return (react_1.default.createElement(Container, { href: noLink ? undefined : gif.url, style: {
            width: width,
            height: height,
        }, className: emotion_1.cx(Gif.className, gifCss, className), onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, onClick: onClick, onContextMenu: function (e) { return onGifRightClick(gif, e); } },
        react_1.default.createElement("div", { style: { width: width, height: height, position: 'relative' }, ref: container },
            react_1.default.createElement("img", { className: Gif.imgClassName, src: showGif ? fit : placeholder, style: { background: background }, width: width, height: height, alt: js_util_1.getAltText(gif), onLoad: showGif ? onImageLoad : function () { } }),
            showGif ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ad_pill_1.default, { bottleData: bottleData, isHovered: isHovered }),
                Overlay && react_1.default.createElement(Overlay, { gif: gif, isHovered: isHovered }))) : null)));
};
Gif.className = 'giphy-gif';
Gif.imgClassName = 'giphy-gif-img';
exports.default = Gif;
var templateObject_1;
//# sourceMappingURL=gif.js.map